import React, { Component } from 'react';
import { Badge, Card, CardBody, Col, Row } from 'reactstrap';

import Loading from '../Loading';
import { callApi, commaNumber } from '../../utils';
import { DOMAINS } from './constants';

// Maps the API response (or the hardcoded fallback) into a uniform shape.
function normalizeDomains(data) {
  if (!Array.isArray(data) || data.length === 0) {
    return DOMAINS.map((domain) => ({ domain, users_count: null }));
  }
  return data.map((d) =>
    typeof d === 'string'
      ? { domain: d, users_count: null }
      : { domain: d.domain, users_count: d.users_count }
  );
}

class DomainsList extends Component {
  state = {
    domains: [],
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.loadDomains();
  }

  loadDomains = () => {
    this.setState({ loading: true, error: null });
    callApi('/domains')
      .then(({ data = [] }) => {
        this.setState({ loading: false, domains: normalizeDomains(data) });
      })
      .catch((err) => {
        // Endpoint may not exist yet — fall back to the fixed enum (no counts)
        // rather than blocking the page.
        this.setState({
          loading: false,
          domains: normalizeDomains([]),
          error: (err && err.message) || null,
        });
      });
  };

  openDomain = (domain) => {
    this.props.history.push(`/domains/${domain}`);
  };

  render() {
    const { domains, loading, error } = this.state;

    return (
      <div className="container-fluid">
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <div style={headerStyle.wrap}>
              <div>
                <h4 style={headerStyle.title}>DOMAINS</h4>
                <p style={headerStyle.sub}>
                  Access domains — select one to see the users who have it.
                </p>
              </div>
            </div>

            {loading ? (
              <Loading />
            ) : (
              <Row>
                {domains.map(({ domain, users_count }) => (
                  <Col key={domain} xs={12} sm={6} lg={4}>
                    <Card
                      className="mb-3"
                      onClick={() => this.openDomain(domain)}
                      style={cardStyle}
                    >
                      <CardBody style={cardBodyStyle}>
                        <div>
                          <Badge color="info" style={{ fontSize: '0.85rem' }}>
                            {domain}
                          </Badge>
                          <div style={countStyle}>
                            {users_count === null || users_count === undefined
                              ? 'View users'
                              : `${commaNumber(users_count)} user${
                                  Number(users_count) === 1 ? '' : 's'
                                }`}
                          </div>
                        </div>
                        <i
                          className="now-ui-icons arrows-1_minimal-right"
                          style={{ color: '#9a9a9a' }}
                        />
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}

            {!loading && error && (
              <p style={{ color: '#9a9a9a', fontSize: '0.8rem' }}>
                Showing the default domain list — live counts are unavailable.
              </p>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const headerStyle = {
  wrap: { marginBottom: 16 },
  title: { margin: 0, fontSize: '1.1rem', fontWeight: 700, color: '#2c2c2c' },
  sub: { margin: '2px 0 0', fontSize: '0.8rem', color: '#9a9a9a' },
};

const cardStyle = { cursor: 'pointer' };

const cardBodyStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const countStyle = {
  marginTop: 8,
  fontSize: '0.85rem',
  color: '#66615b',
  fontWeight: 600,
};

export default DomainsList;
